/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../reducers';

interface AuthorEmailProps {
    authorId: string | null;
}

const AuthorEmail = ({ authorId }: AuthorEmailProps) => {
    const { users } = useSelector((state: ReduxStateShape) => ({
        users: state.users?.users,
    }));

    let authorEmail = '-';

    if (authorId && users) {
        const getAuthor = () => {
            Object.entries(users).forEach(([_key, value]) => {
                if (value.Id === authorId) {
                    authorEmail = value.Email as string;
                }
            });
        };
        getAuthor();
    }

    return <>{authorEmail}</>;
};

export default AuthorEmail;
